<template>
	<ParamWrapper v-bind="wrapperProps" @input-data-closed="onDataInputMenuClose">
		<component :is="component" v-bind="componentProps" v-on="componentListeners" />
		<template v-slot:input-data>
			<slot name="input-data">
				<BooleanDataInputMenu
					:param="param"
					v-on="dataInputListeners"
					@update-external-localValue="updateSelectValue"
					ref="data-input-menu"
				/>
			</slot>
		</template>
	</ParamWrapper>
</template>

<script>
import { SELECT_TAB_KEY } from '../../../DataInput/DataInputMenu/helpers/data-input-menu.const';
import BooleanDataInputMenu from '../DataInputMenus/BooleanDataInputMenu';
import ParamTypeExtenderDataInputMenuMixin from './mixins/ParamTypeExtenderDataInputMenuMixin';
import ThisFlowMixin from './mixins/ThisFlowMixin';
import ParamTypeMixin from './mixins/ParamTypeMixin';
import DefaultPropertyInput from '../inputsComponents/DefaultPropertyInput';
import DefaultPropertyDropdownInput from '../inputsComponents/DefaultPropertyDropdownInput';
import ParamTypeHelper from './param-type-helper';
export default {
	name: 'BooleanParamType',
	mixins: [ParamTypeMixin, ParamTypeExtenderDataInputMenuMixin, ThisFlowMixin],
	components: { BooleanDataInputMenu, DefaultPropertyInput, DefaultPropertyDropdownInput },
	computed: {
		selectItems() {
			return [
				{ option: 'Yes', value: true },
				{ option: 'No', value: false },
			];
		},
		fromSelectOptions() {
			return this.curTabCode === SELECT_TAB_KEY;
		},
		componentConfig() {
			const EXTERNAL_VALUE_PROPS = {
				...this.$attrs,
				value: this.localValueDisplay,
				rules: this.fieldRules,
				inputFieldHint: this.param.placeholder,
				isDropdownOpen: this.showDataMenu,
				isFocused: this.isFocused,
				showDataMenu: this.showDataMenu,
				readonly: this.readonly,
				ref: 'richEditor',
			};
			const RICH_TEXT_BOX_PROPS = {
				...this.buildCommonRichTextBoxProps(),
				...this.$attrs,
				inputFieldHint: this.param.placeholder,
				value: this.localValue,
				ref: 'richEditor',
				readonly: this.readonly,
				isFocused: this.isFocused,
				showDataMenu: this.showDataMenu,
			};
			const EXTERNAL_VALUE_LISTENERS = {
				'clear-value': this.clearValue,
				focus: this.onInputFocus,
				blur: this.onInputBlur,
				click: this.onInputClick,
				open: this.openDataInputMenu,
			};
			const RICH_TEXT_BOX_LISTENERS = {
				focus: this.onInputFocus,
				blur: this.onInputBlur,
				input: (val) => (this.localValue = val),
				click: this.onInputClick,
				open: this.openDataInputMenu,
			};

			const REGULAR_PROPERTY_INPUT_CONFIG = ParamTypeHelper.buildComponentConfigItem(
				DefaultPropertyInput,
				RICH_TEXT_BOX_PROPS,
				RICH_TEXT_BOX_LISTENERS
			);
			const REGULAR_PROPERTY_DROPDOWN_INPUT_CONFIG = ParamTypeHelper.buildComponentConfigItem(
				DefaultPropertyDropdownInput,
				EXTERNAL_VALUE_PROPS,
				EXTERNAL_VALUE_LISTENERS
			);
			return this.fromSelectOptions ? REGULAR_PROPERTY_DROPDOWN_INPUT_CONFIG : REGULAR_PROPERTY_INPUT_CONFIG;
		},
		component() {
			return this.componentConfig.component;
		},
		componentProps() {
			return this.componentConfig.props;
		},
		componentListeners() {
			return this.componentConfig.listeners;
		},
		booleanDataInputMenuProps() {
			return { items: this.selectItems };
		},
	},
	methods: {
		addSelectTabItem() {
			const fieldName = 'Yes / No';
			this.addTabItem(SELECT_TAB_KEY, fieldName, true);
		},
		clearValue() {
			this.updateSelectValue({ id: '', name: '' });
		},
		updateSelectValue(payload) {
			this.updateConstantValueFromDataInputMenu(payload);
		},
		setBooleanDataInputMenuProps() {
			Object.entries(this.booleanDataInputMenuProps).forEach(([key, value]) => this.setDataInputMenuProp(key, value));
		},
	},
	mounted() {
		this.addSelectTabItem();
		// applies label of selected option, if exists
		this.applyLabelFromOptions(this.selectItems);
	},
	watch: {
		booleanDataInputMenuProps: {
			handler() {
				this.setBooleanDataInputMenuProps();
			},
			deep: true,
			immediate: true,
		},
		componentConfig: {
			handler() {
				this.$nextTick(() => {
					this.setInputElement(this.$refs['richEditor']?.$el);
				});
			},
		},
	},
};
</script>
<style lang="scss" scoped></style>
